"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@chakra-ui/react");
function AlertDialog(_a) {
    var { isOpen, leastDestructiveRef, onClose, footer, header, children } = _a, props = __rest(_a, ["isOpen", "leastDestructiveRef", "onClose", "footer", "header", "children"]);
    return ((0, jsx_runtime_1.jsx)(react_1.AlertDialog, Object.assign({ isOpen: isOpen, leastDestructiveRef: leastDestructiveRef, onClose: onClose }, props, { children: (0, jsx_runtime_1.jsx)(react_1.AlertDialogOverlay, { children: (0, jsx_runtime_1.jsxs)(react_1.AlertDialogContent, { children: [header ? ((0, jsx_runtime_1.jsx)(react_1.AlertDialogHeader, Object.assign({ fontSize: "lg", fontWeight: "bold" }, { children: header }))) : null, children, footer ? (0, jsx_runtime_1.jsx)(react_1.AlertDialogFooter, { children: footer }) : null] }) }) })));
}
exports.AlertDialog = AlertDialog;
AlertDialog.BaseAlertDialog = react_1.AlertDialog;
AlertDialog.Overlay = react_1.AlertDialogOverlay;
AlertDialog.Content = react_1.AlertDialogContent;
AlertDialog.Header = react_1.AlertDialogHeader;
AlertDialog.Body = react_1.AlertDialogBody;
AlertDialog.Footer = react_1.AlertDialogFooter;
